import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";

export default function Books() {
  const { i18n } = useTranslation();
  const [books, setBooks] = useState([]);
  useEffect(() => { api.get(`/books?lang=${i18n.language || "en"}`).then(({ data }) => setBooks(data)); }, [i18n.language]);

  return (
    <div className="container-narrow py-12 md:py-16" data-testid="books-page">
      <div className="text-center mb-10">
        <div className="label-eyebrow mb-3">Pop-up bookshop</div>
        <h1 className="font-heading text-4xl md:text-6xl font-semibold leading-tight">
          Computer science <span className="italic text-marigold">you can touch.</span>
        </h1>
        <p className="text-ink2 mt-4 max-w-2xl mx-auto">
          Hardcover pop-ups and digital interactive books. Algorithms, networks, AI, SwiftUI — all paper-craft warm.
        </p>
      </div>

      <div className="card-soft border-2 border-teal/60 bg-teal/10 px-6 py-4 mb-12 max-w-3xl mx-auto text-center" data-testid="books-store-banner">
        <div className="inline-flex items-center gap-2 text-teal font-semibold text-sm uppercase tracking-widest">
          <span className="w-2 h-2 rounded-full bg-teal" />
          Now shipping · Preorders open
        </div>
        <p className="text-ink mt-2">
          Every book has hardcover pop-up + digital editions. Preorder now to lock in launch pricing —
          your digital copy unlocks the moment it&apos;s printed.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {books.map(b => (
          <Link key={b.id} to={`/books/${b.id}`} className="card-book p-5 block relative" data-testid={`book-card-${b.id}`}>
            {b.status !== "available" && (
              <div className="absolute -top-3 -right-3 z-10 px-3 py-1 rounded-full bg-saffron border-2 border-ink shadow-[3px_3px_0_0_#1A1B41] text-[10px] font-bold text-ink uppercase tracking-widest">
                Preorder
              </div>
            )}
            {b.status === "available" && (
              <div className="absolute -top-3 -right-3 z-10 px-3 py-1 rounded-full bg-teal border-2 border-ink shadow-[3px_3px_0_0_#1A1B41] text-[10px] font-bold text-cream uppercase tracking-widest">
                Available
              </div>
            )}
            <div className="aspect-[3/4] rounded-xl overflow-hidden mb-4 relative" style={{ background: b.color }}>
              <img src={b.cover} alt="" className="w-full h-full object-cover mix-blend-multiply opacity-90" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent" />
              <div className="absolute bottom-3 left-4 right-4 text-cream">
                <div className="text-[10px] uppercase tracking-widest opacity-80">{b.format}</div>
                <div className="font-heading text-xl leading-tight">{b.title}</div>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="text-sm text-ink2 italic line-clamp-2 pr-3">{b.tagline}</div>
              <div className="text-right">
                <div className="font-heading text-lg font-semibold">₹{b.price_inr}</div>
                <div className="text-xs text-ink2">€{b.price_eur}</div>
              </div>
            </div>
            <div className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-marigold">
              {b.status === "available" ? "Buy now" : "Preorder"} →
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
